export const DAO_CODE = "CONTRACT_DAO"
